import {useSubheader} from "../../../_metronic/layout";
import React, {useState} from "react";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {makeFormDataRequest} from "../../api/makeRequest";
import "react-bootstrap/cjs/divWithClassName";


export const ImportUserPage = () => {
	const { t } = useTranslation('common');
	const suhbeader = useSubheader();
	suhbeader.setTitle(t('MENU.EXCEL_IMPORT_USER'));

	const [loading, setLoading] = useState(false);
	const [okMessage,setOkMessage] = useState('');

	const [file,setFile] = useState(null)
	const [status,setStatus] = useState("")
	const [errors,setErrors] = useState({})


	const enableLoading = () => {
		setLoading(true);
	};

	const disableLoading = () => {
		setLoading(false);
	};


	let history = useHistory();

	const handleSubmit = (e)=>{
		e.preventDefault()
		if (!file) {
			setErrors(prev=>({
				...prev,
				excel:t('SelectFile')
			}))
			return
		}
		enableLoading();
		const formData = new FormData()
		formData.append('excel',file)
		makeFormDataRequest('panel/import/user',formData )
			.then(({data}) => {
			const {success} = data
			if(success) {
				setOkMessage(t('UsersAdded'))
				setTimeout(()=>{
					history.push('/user')
				},1000)
			}else{
				const {error} = data
				setStatus(error)
			}
		}).catch((e) => {
			setStatus(t('Error'))
		}).finally(() => {
			disableLoading();
		})
	}

	return (
		<>
			<form
				onSubmit={handleSubmit}
				className="form fv-plugins-bootstrap fv-plugins-framework"
			>
				{status ? (
					<div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
						<div className="alert-text font-weight-bold">{status}</div>
					</div>
				) : null}
				{okMessage ? (
					<div className="mb-10 alert alert-custom alert-light-success alert-dismissible">
						<div className="alert-text font-weight-bold">{okMessage}</div>
					</div>
				) : null}

				<div className="form-group fv-plugins-icon-container">
					<input
						type="file"
						className={`form-control form-control-solid h-auto py-5 px-6`}
						name="excel"
						onChange={(e)=>{

							if(e.target.files.length < 1){
								setErrors(prev=>({
									...prev,
									excel:t('SelectFile')
								}))
								setFile(null)
								e.target.value = null
								return;
							}

							if(!e.target.files[0].name.toLowerCase().includes('xlsx') &&
								!e.target.files[0].name.toLowerCase().includes('xls')){
									setErrors(prev=>({
										...prev,
										excel:"(xlsx,slx) t('Format')"
									}))
								e.target.value = null
									return;
							}

							let lenMb = parseInt(e.target.files[0].size / 1024 / 1024 * 10)/10;

							if(lenMb > 50){
								setErrors(prev=>({
									...prev,
									excel:t('SizeMax50')
								}))
								e.target.value = null
								return;
							}
							setFile(e.target.files[0]);
						}}
					/>
					{errors.excel ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{errors.excel}</div>
						</div>
					) : null}
				</div>
				<div className="exel-example">
					<a href="https://bellmeet.com/helpvideo/example.xlsx">{t('ExampleExcel')}</a>
				</div>
				<div className="form-group d-flex flex-wrap justify-content-between align-items-center">
					<button
						id="kt_login_signin_submit"
						type="submit"
						disabled={loading}
						className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
					>
						<span>{t('MENU.EXCEL_IMPORT')}</span>
						{loading && <span className="blockui m-1 ml-3 spinner spinner-white"/>}
					</button>
				</div>
			</form>
		</>
	)
}
